import { useTranslation } from "react-i18next";

const SfmaHakthonBanner = () => {
  useTranslation();

  // SFMA Hackathon
  // return (
  //   <section
  //     className="visit-saudi-company-3 relative md:h-[50vh] h-[28vh] md:mt-10 mt-4 shadow-2xl "
  //     dir={i18n.language === "en" ? "ltr" : "rtl"}
  //   >
  //     <div className="text-right container" style={{ zIndex: 2 }}>
  //       <div className="flex flex-col items-center lg:-translate-y-14 lg:-translate-x-20">
  //         <div className="col-span-12 my-auto text-white ">
  //           <p className="lg:text-5xl text-[#00b5ad] text-3xl font-bold md:text-justify text-center leading-normal mx-3">
  //             {t("hackathon.title")}
  //           </p>
  //         </div>
  //         <div className="lg:col-span-6 md:col-span-6 col-span-12 lg:block md:block flex justify-center lg:mt-8 mt-4">
  //           <Link
  //             to={`/${i18n.language}/SfmaHackathon`}
  //             rel="noopener noreferrer"
  //             className="block lg:px-12 px-6 py-3 rounded-full bg-[#e65403] hover:opacity-90 font-semibold lg:text-[32px] text-xl"
  //           >
  //             {t("hackathon.go_ahead")}
  //           </Link>
  //         </div>
  //       </div>
  //     </div>
  //   </section>
  // );
  return null;
};

export default SfmaHakthonBanner;
